import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";

import EngagementListItem from "../engagements/EngagementListItem";
import { borders } from "../theme/theme";

interface DashboardEngagementsProps {
  engagements: any[];
  onEngagementClick: (publicId: string) => void;
}

function DashboardEngagements(props: DashboardEngagementsProps) {
  const { engagements, onEngagementClick } = props;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 2,
        border: "1px solid",
        borderColor: borders.light,
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Your Engagements
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {engagements?.length
            ? `You have ${engagements.length} engagement${engagements.length !== 1 ? "s" : ""}`
            : "Your active and past client engagements"}
        </Typography>
      </Box>

      {(!engagements || !engagements.length) && (
        <Box
          sx={{
            py: 6,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: "text.secondary",
          }}
        >
          <WorkOutlineIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
          <Typography>You do not have any engagements yet.</Typography>
        </Box>
      )}

      {engagements && engagements.length ? (
        <List sx={{ p: 0 }}>
          {engagements.map((engagement: any) => (
            <EngagementListItem
              key={engagement.id}
              onEngagementClick={onEngagementClick}
              engagement={engagement}
            />
          ))}
        </List>
      ) : null}
    </Paper>
  );
}

export default DashboardEngagements;
